import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "jobs",
  "use": "jobs-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"jobs\"><path d=\"M458.903 178.538c-11.105-15.146-26.587-32.85-43.589-49.852s-34.706-32.482-49.852-43.589C339.675 66.187 327.166 64 320 64H136c-22.057 0-40 17.944-40 40v368c0 22.056 17.943 40 40 40h304c22.056 0 40-17.944 40-40V224c0-7.166-2.186-19.675-21.097-45.462zm-66.216-27.225c15.35 15.35 27.4 29.199 36.29 40.687H352v-76.973c11.491 8.89 25.339 20.939 40.687 36.286zM448 472c0 4.336-3.664 8-8 8H136c-4.336 0-8-3.664-8-8V104c0-4.336 3.664-8 8-8h184v112c0 8.836 7.162 16 16 16h112v248z\" /><path d=\"M301.462 21.098C275.675 2.187 263.166 0 256 0H72C49.944 0 32 17.944 32 40v368c0 19.316 13.764 35.479 32 39.195V40c0-4.336 3.664-8 8-8h243.438c-4.823-3.96-9.514-7.63-13.976-10.902z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/jobs.svg
// module id = v4jp
// module chunks = 1